import { Component, OnInit, Input, Renderer2, OnDestroy, SimpleChanges } from '@angular/core';
import { isTabAllowed, tabRouteCommands } from './tab-navigation.rules';

@Component({
  selector: 'ecpl-tab-navigation',
  templateUrl: './ecpl-tab-navigation.component.html',
  styleUrls: ['./ecpl-tab-navigation.component.css'],
  standalone: false
})
export class EcplTabNavigationComponent implements OnInit {
  @Input() linkItems: any;
  @Input() parentId: any;
  @Input() linkAccess: any = null;
  @Input() parentKey: any;
  constructor() { }

  //#region page-events
  /**
   * page init event
   */
  ngOnInit() { }

  
  //#endregion

  /**
   * get route for navigation
   * @param linkItem {any}
   */
  getRoute(linkItem: any) {
    return tabRouteCommands(linkItem.linkText, this.parentId, this.parentKey);
  }

  /**
   * check user rights for tabs
   * @param item {number}
   */
  checkUserRights(item: number): boolean {
    return isTabAllowed(this.linkAccess, item);
  }

}
